<div
  class='hr_slide_history'
  [ngClass]="{
    negMarginTop: this.eStatus.phase !== 'post-live' && screenwidth > 1023
  }"
  >
  <div class='hr_dropdown_slides'>
    @if (screenwidth > 1023) {
      <div class='hr_collapsible_slides'>
        <button
          type='button'
          class='hr_btn_collapsible'
          (click)='toggleSlideflow()'
          >
          <span
          [ngClass]="{
            active: this.showSlideFlow == 'in'
          }"
            class='arrow'
            >
            <span></span>
            <span></span>
          </span>
          <span>{{ eLangGlob.translateSlideHistory }}</span>
        </button>
      </div>
    }
    @if (eStatus?.phase != 'post-live' && screenwidth > 1023) {
      <div class='hr_current_slide'>
        <span
          class='cur_slide_left'
        [ngClass]='{
          cur_slide_left_disabled: this.selectedSlideObject?._id === this.playlist[this.playlist.length - 1]?._id
        }'
        ></span>
        <button
          class='btn_current_slide'
        [ngClass]='{
          btn_current_slide_disabled: this.selectedSlideObject?._id === this.playlist[this.playlist.length - 1]?._id
        }'
          (click)='this.selectSlide(this.playlist[this.playlist.length - 1])'
          >
          <span>{{ eLangGlob.translateCurSlide }}</span>
        </button>
        <span
          class='cur_slide_right'
        [ngClass]='{
          cur_slide_right_disabled: this.selectedSlideObject?._id === this.playlist[this.playlist?.length - 1]?._id
        }'
        ></span>
      </div>
    }
  </div>
  <div class='hr_collapsed_slides' [@slideInOut]='showSlideFlow'>
    <div class='historyBox'>
      <button (click)="scroll('left')" class='ff arrow-left'></button>
      <div class='coverflow_style' #slideHistoryContent>
        @for (playlistObject of playlist; track playlistObject?._id; let i = $index) {
          <lse-slidelist-item
            (click)='this.selectSlide(playlistObject)'
            [playlistObject]='playlistObject'
            [path]='path'
            [selectedLanguage]='selectedLanguage'
            [eventFolder]='eventFolder'
            [languages]='languages'
            [selectedSlideObject]='selectedSlideObject'
            [selectedSlideObjectIndex]='selectedSlideObjectIndex'
            #slideDiv
          ></lse-slidelist-item>
        }
      </div>
      <button (click)="scroll('right')" class='ff arrow-right'></button>
    </div>
  </div>
  @if (screenwidth > 1023) {
    <hr />
  }
</div>
